import React from "react";

import { ReactComponent as EmptyIcon } from "assets/images/app_svg/activities_empty.svg";

function empty() {
  return (
    <div className="web_logs_empty">
      <div className="web_logs_empty_screen">
        <div className="img_holder flex_center">
          <EmptyIcon />
        </div>
        <p>No activities to view</p>
      </div>
    </div>
  );
}

export default empty;
